import { render, staticRenderFns } from "./DanhSachChung.vue?vue&type=template&id=2fc181ea&"
import script from "./DanhSachChung.vue?vue&type=script&lang=js&"
export * from "./DanhSachChung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports